<template>
  <section :style="'background:' + projectColors.bg">
    <!-- <section> -->
    <div class="w-100 pt-0">
      <h3
        :style="'color:' + projectColors.title"
        class="text-center text-xl font-black uppercase"
      >
        {{ projectName.replace("_", " ") }}
      </h3>
    </div>

    <div class="mt-2 space-y-3 px-3">
      <!-- Boxes and Pies -->
      <div class="">
        <BoxPieCharts
          :totalAmount="paymentData.total_amount"
          :totalCount="paymentData.total_count"
          :groupSuccess="paymentData.group_transaction_count.success"
          :groupFailed="paymentData.group_transaction_count.failed"
        />
      </div>

      <!-- lines -->
      <div class="">
        <LineCharts
          :bg_line="projectColors.bg_line"
          :bg_text="projectColors.bg_text"
          :todayData="paymentData.today"
          :yesterdayData="paymentData.yesterday"
        />
      </div>

      <!-- bars -->
      <div class="">
        <BarCharts
          :bg_line="projectColors.bg_line"
          :bg_text="projectColors.bg_text"
          :thisWeekData="paymentData.this_week"
          :lastWeekData="paymentData.last_week"
          :thisMonthData="paymentData.this_month"
          :thisYearData="paymentData.this_year"
        />
      </div>
    </div>
  </section>
</template>

<script>
import BoxPieCharts from "@/components/Payments/BoxPieCharts.vue";
import LineCharts from "@/components/Payments/LineCharts.vue";
import BarCharts from "@/components/Payments/BarCharts.vue";
export default {
  name: "Payment",
  props: {
    paymentData: Object,
    projectName: String,
    projectColors: Object,
  },
  components: {
    BoxPieCharts,
    LineCharts,
    BarCharts,
  },
  data() {
    return {};
  },
};
</script>
